import { useTranslation, useSiteContext } from '@eti/providers';
import { css, cx, mediaQueries } from '@eti/styles';
import { FilterType } from '@eti/schema-types';
import { TRAVEL_TIME } from '../../../../constants/searchFiltersConstants';
import type { RangeType } from '../../models';
import { getDurationAttributes } from '../../../../common/time/utils';
import { useDurationFormatter } from './utils/searchFilters';
import ValueSliderFilter from './ValueSliderFilter';
import type { Filters } from './v3/MobileFilters';

const filterStyles = css`
  @media ${mediaQueries.medium.up} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 16px;

    & header {
      align-items: flex-start;
    }
  }
`;

type TravelTimeProps = {
  className: string;
  isInitiallyExpanded: boolean;
  isToggleable: boolean;
  onFilter: (filter: any) => void;
  travelTimeRange: RangeType;
  selectedFilters: Filters | null | undefined;
};

const TravelTime = ({
  className,
  isInitiallyExpanded,
  isToggleable,
  onFilter,
  travelTimeRange,
  selectedFilters,
}: TravelTimeProps) => {
  const { t } = useTranslation();
  const { formatDurationValue } = useDurationFormatter();
  const { language } = useSiteContext();

  const formatAriaValue = (value: number): string =>
    getDurationAttributes(language.locale, value).ariaLabel;

  const halfHour = 1000 * 60 * 30;
  return (
    <ValueSliderFilter
      className={cx(className, filterStyles)}
      formatAriaValue={formatAriaValue}
      formatDisplayedValue={formatDurationValue}
      isInitiallyExpanded={isInitiallyExpanded}
      isToggleable={isToggleable}
      label={t('Result.SearchFilters.TravelTime.Text')}
      maxValue={travelTimeRange.max}
      minValue={travelTimeRange.min}
      name={FilterType.TravelTime}
      onFilter={onFilter}
      selectedValue={selectedFilters?.[TRAVEL_TIME]}
      step={halfHour}
    />
  );
};

export default TravelTime;
